<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import managementReviewAPI from "@/services/standards/managementReview/managementReviewAPI";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import VersionNote from "@/components/document/VersionNote.vue";

export default {
  page: { title: "Acta de Revisión por la Alta Dirección" },
  components: { VersionNote, Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      // Texto que queda en el control de versiones del PDF
      versionNote: "",
      title: "6.1.3 Acta de Revisión por la Alta Dirección",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "6.1.3 Revisión por la Alta Dirección", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      reviewId: this.$route.params.review || null,
      temasCatalog: [],
      form: {
        acta_numero: null,
        fecha: new Date().toISOString().substring(0, 10),
        hora_inicio: null,
        hora_fin: null,
        observaciones_adicionales: null,
      },
      participants: [{ nombre: "", cargo: "" }],
      temas: [],
      commitments: [{ actividad: "", responsable: "", fecha_cumplimiento: null }],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    reviewApi() {
      return {
        pdfUrl: (id) => managementReviewAPI.pdfUrl(id),
        sign: (id, payload) => managementReviewAPI.sign(id, payload),
      };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    addParticipant() { if (!this.isSigned) this.participants.push({ nombre: "", cargo: "" }); },
    removeParticipant(idx) {
      if (this.isSigned) return;
      this.participants.splice(idx, 1);
      if (!this.participants.length) this.participants.push({ nombre: "", cargo: "" });
    },
    addCommitment() { if (!this.isSigned) this.commitments.push({ actividad: "", responsable: "", fecha_cumplimiento: null }); },
    removeCommitment(idx) {
      if (this.isSigned) return;
      this.commitments.splice(idx, 1);
      if (!this.commitments.length) this.commitments.push({ actividad: "", responsable: "", fecha_cumplimiento: null });
    },
    // Inicializa el arreglo de temas (uno por tema del catálogo) preservando lo ya capturado.
    syncTemas(existing) {
      this.temas = this.temasCatalog.map((_, i) => (existing && existing[i] != null ? existing[i] : ""));
    },
    load() {
      if (!this.reviewId) { this.loading = false; return; }
      managementReviewAPI.get(this.reviewId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.acta_numero = r.acta_numero || null;
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.hora_inicio = r.hora_inicio ? String(r.hora_inicio).substring(0, 5) : null;
          this.form.hora_fin = r.hora_fin ? String(r.hora_fin).substring(0, 5) : null;
          this.form.observaciones_adicionales = r.observaciones_adicionales || null;
          this.participants = (r.participants && r.participants.length) ? r.participants : [{ nombre: "", cargo: "" }];
          this.commitments = (r.commitments && r.commitments.length) ? r.commitments : [{ actividad: "", responsable: "", fecha_cumplimiento: null }];
          this.syncTemas(r.temas);
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = {
        companies_id: this.companyID,
        ...this.form,
        participants: this.participants,
        temas: this.temas,
        commitments: this.commitments,
      };
      payload.version_note = this.versionNote;
      const req = this.reviewId ? managementReviewAPI.update(this.reviewId, payload) : managementReviewAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 55, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Acta guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.reviewId && res && res.id) {
            this.reviewId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/revision-direccion/${res.id}` });
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar el acta", "error"); });
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    managementReviewAPI.meta()
      .then((m) => {
        this.temasCatalog = (m && m.temas) ? m.temas : [];
        if (!this.temas.length) this.syncTemas(null);
        this.load();
      })
      .catch((e) => { console.log(e); this.load(); });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Diligencia el acta de la revisión anual por la alta dirección: encabezado, participantes, el análisis de
                los 15 temas exigidos por el Decreto 1072 de 2015 y los compromisos. La plataforma genera el acta para la
                firma de la alta dirección (representante legal).
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta acta ya fue firmada; los datos quedan bloqueados para edición.
            </div>

            <form @submit.prevent="save">
              <!-- Encabezado -->
              <h5 class="pt-2">Encabezado</h5>
              <div class="form-row">
                <b-form-group class="col-md-3 px-2" label="N° acta de reunión">
                  <b-form-input type="text" v-model="form.acta_numero" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha">
                  <b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Hora inicio">
                  <b-form-input type="time" v-model="form.hora_inicio" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Hora fin">
                  <b-form-input type="time" v-model="form.hora_fin" :disabled="isSigned" />
                </b-form-group>
              </div>

              <!-- Participantes -->
              <hr />
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Verificación de participantes</h5>
                <button type="button" class="btn btn-outline-primary btn-sm" :disabled="isSigned" @click="addParticipant">
                  <i class="mdi mdi-plus"></i> Agregar
                </button>
              </div>
              <div v-for="(p, idx) in participants" :key="'p' + idx" class="form-row align-items-end mt-1">
                <b-form-group class="col-md-6 px-2" :label="idx === 0 ? 'Nombres y apellidos' : ''">
                  <b-form-input v-model="p.nombre" :disabled="isSigned" size="sm" />
                </b-form-group>
                <b-form-group class="col-md-5 px-2" :label="idx === 0 ? 'Cargo' : ''">
                  <b-form-input v-model="p.cargo" :disabled="isSigned" size="sm" />
                </b-form-group>
                <div class="col-md-1 px-2 pb-2">
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeParticipant(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>
              </div>
              <p class="text-muted small mt-1">La firma de cada participante se recoge físicamente en el acta impresa.</p>

              <!-- 15 temas -->
              <hr />
              <h5>Temas a tratar y análisis correspondiente</h5>
              <div v-for="(t, idx) in temasCatalog" :key="'t' + idx" class="mb-2">
                <label class="font-weight-bold small mb-1">{{ idx + 1 }}. {{ t }}</label>
                <b-form-textarea v-model="temas[idx]" :disabled="isSigned" rows="2" size="sm" />
              </div>
              <b-form-group label="Observaciones adicionales">
                <b-form-textarea v-model="form.observaciones_adicionales" :disabled="isSigned" rows="2" />
              </b-form-group>

              <!-- Compromisos -->
              <hr />
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Compromisos</h5>
                <button type="button" class="btn btn-outline-primary btn-sm" :disabled="isSigned" @click="addCommitment">
                  <i class="mdi mdi-plus"></i> Agregar
                </button>
              </div>
              <div v-for="(c, idx) in commitments" :key="'c' + idx" class="form-row align-items-end mt-1">
                <b-form-group class="col-md-5 px-2" :label="idx === 0 ? 'Actividad' : ''">
                  <b-form-input v-model="c.actividad" :disabled="isSigned" size="sm" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" :label="idx === 0 ? 'Responsable' : ''">
                  <b-form-input v-model="c.responsable" :disabled="isSigned" size="sm" />
                </b-form-group>
                <b-form-group class="col-md-2 px-2" :label="idx === 0 ? 'Fecha cumplimiento' : ''">
                  <b-form-input type="date" v-model="c.fecha_cumplimiento" :disabled="isSigned" size="sm" />
                </b-form-group>
                <div class="col-md-1 px-2 pb-2">
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeCommitment(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>
              </div>

              <VersionNote v-model="versionNote" :editing="!!reviewId" />

              <div class="text-right mt-2">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && reviewId">
        <h6 class="text-muted small mb-1">Acta de Revisión por la Dirección</h6>
        <DocumentActions
          :document-id="Number(reviewId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="reviewApi"
          document-title="Acta de Revisión por la Alta Dirección"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
